import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { BrandThemes } from '../../organisms/BrandThemes';

const brandThemesValidateSearch = z
  .object({
    type: z.enum(['add', 'edit']).optional(),
    uuid: z.string().optional(),
  })
  .optional();

export const Route = createFileRoute('/_authenticated/brand-themes')({
  component: BrandThemes,
  validateSearch: brandThemesValidateSearch,
});
